import React, { Children, ReactNode } from 'react';
import styled from 'styled-components';

import { basic } from '../../theme/colors';

const MAX_VISIBLE_ITEMS = 20;

interface FilterToggleWrapperProps {
  children?: ReactNode;
  maxItems?: number;
}

const Wrapper = styled.div.attrs({
  role: 'group',
  'aria-label': 'Selected filters',
})`
  background: transparent;
  border: none;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const MoreIndicator = styled.span`
  display: inline-block;

  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  background: ${basic.haydenBorder};
  text-align: center;
  border-radius: 4px;
  padding: 4px 8px;
  color: ${basic.haydenAccent};
  margin-right: 8px;
  margin-bottom: 4px;
`;

export function FilterToggleWrapper({ children, maxItems = MAX_VISIBLE_ITEMS }: FilterToggleWrapperProps) {
  const childArray = Children.toArray(children);
  const totalCount = childArray.length;
  const hasMore = totalCount > maxItems;
  const visibleChildren = hasMore ? childArray.slice(0, maxItems) : childArray;
  const hiddenCount = totalCount - maxItems;

  return (
    <Wrapper>
      {visibleChildren}
      {hasMore && <MoreIndicator>+ {hiddenCount} more</MoreIndicator>}
    </Wrapper>
  );
}
